import {motion, tokens as motionTokens} from '@sail/motion';

// Shared height + fade reveal used when refund controls appear, disappear, or
// swap (funding method switch, "set a new refund address" address field).
export const refundRevealAnimation = motion({
  initial: {height: 0, opacity: 0},
  animate: {height: 'auto', opacity: 1},
  exit: {height: 0, opacity: 0},
  transition: {duration: 0.2, ease: motionTokens.easing.smooth},
});
